import React, { createContext, useContext, useState, useEffect } from 'react';
import { message } from 'antd';
import { useCaseViewContext } from './CaseViewContext';

const USStatesContext = createContext();

export const useUSStatesContext = () => {
    const context = useContext(USStatesContext);
    if (!context) {
        throw new Error("useUSStatesContext must be used within a USStatesProvider");
    }
    return context;
}

export const USStatesProvider = ({ children, value }) => {
    const { apiType, apiClasses } = useCaseViewContext();
    const [usStates, setUSStates] = useState([])

    const apiCall = apiType === 'admin' ?  apiClasses.LookUpAPI?.lookUp : apiClasses.APIHelper?.fetchLookUp;
    
    useEffect(() => {
       apiCall('state')
            .then(res => setUSStates(res.data.payload))
            .catch(() => message.error('Unable to fetch list of US states'));
    }, [value?.caseDetails])
    
    
    const enhancedValue = {
        ...value,
        usStates
    }
    
    return (
        <USStatesContext.Provider value={enhancedValue}>
            {children}
        </USStatesContext.Provider>
    );
};
